/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityPhysiciansInner
 */
export interface FacilityPhysiciansInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    physician_name?: string;
    /**
     * 
     */
    physician_npi?: string;
    /**
     * 
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the FacilityPhysiciansInner interface.
 */
export function instanceOfFacilityPhysiciansInner(value: object): value is FacilityPhysiciansInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FacilityPhysiciansInnerFromJSON(json: any): FacilityPhysiciansInner {
    return FacilityPhysiciansInnerFromJSONTyped(json, false);
}

export function FacilityPhysiciansInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityPhysiciansInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'physician_name': json['physician_name'] == null ? undefined : json['physician_name'],
        'physician_npi': json['physician_npi'] == null ? undefined : json['physician_npi'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function FacilityPhysiciansInnerToJSON(json: any): FacilityPhysiciansInner {
    return FacilityPhysiciansInnerToJSONTyped(json, false);
}

export function FacilityPhysiciansInnerToJSONTyped(value?: FacilityPhysiciansInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'physician_name': value['physician_name'],
        'physician_npi': value['physician_npi'],
        'is_default': value['is_default'],
    };
}

